module.exports = __webpack_public_path__ + "img/game.d9534c53.webp";